// @flow

import { type WelcomeMessage } from '../../../models'

import { type State } from './state'

export const mutations = {
  setForceShowWelcomeMessage (state: State, {
    value,
    payload
  }: { value: boolean, payload: ?string }) {
    state.forceShowWelcomeMessage = value
    if (payload) state.forceShowWelcomeMessagePayload = payload
  },
  setWelcomeMessage (state: State, welcomeMessage: WelcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  setWelcomeMessages (state: State, welcomeMessages: Array<WelcomeMessage>) {
    state.welcomeMessages = welcomeMessages
  },
  setClosedByUserAt (state: State, value: string) {
    state.closedByUserAt = value
  }
}
